import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
HighchartsMore(Highcharts);

@Injectable({
    providedIn: 'root'
})
export class ColumnrangeService {

    constructor() { }

    getOptions(yAxisTitle, series, categories, inverted, height, stacking) {
        const options: Highcharts.Options = {
            chart: {
                inverted: inverted,
                type: 'columnrange',
                height: height
            },
            title: {
                text: ''
            },
            xAxis: {
                categories: categories,
                title: {
                    text: null
                }
            },
            yAxis: {
                allowDecimals: false,
                title: {
                    text: yAxisTitle
                }
            },
            plotOptions: {
                column: {
                    dataLabels: {
                        enabled: false
                    }
                },
                series: {
                    label: {
                        enabled: false
                    },
                    stacking: stacking
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            tooltip: {
                valueDecimals: 2
            },
            series: series
        };

        return options;
    }
}
